import styled from "@emotion/styled"
import { Container } from "@mui/material"

const NotFoundContainer = styled(Container)`
    &&& {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 10vh;
        padding-bottom: 10vh;
    }
`

const NotFound: React.FC = () => {
    return (
        <NotFoundContainer>
            <h1>Looks like nothing's here</h1>
            <h6>Maybe visit some of these links or something...</h6>
        </NotFoundContainer>
    )
}

export default NotFound